var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showFullScreenBtn)?_c('div',{on:{"click":_vm.handleChange}},[_c('Tooltip',{attrs:{"content":_vm.value ? '退出全屏' : '全屏',"placement":"bottom"}},[_c('Icon',{staticClass:"category-item-icon",attrs:{"type":_vm.value ? 'md-contract' : 'md-qr-scanner'}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }